export default "__VITE_ASSET__n9_Nh1tR__"